module.exports = __webpack_public_path__ + "spine/Goat_big.json?82fe7e68f11d95399e92dab07b7f8598";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/goat/Goat_big.json
// module id = 1742
// module chunks = 3